// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3b254d7e","455":"8399d533","977":"0c5c58cf"}[chunkId] + ".chunk.js";
};